import { useEffect, useState } from 'react';
import { IS_NATIVE } from '../native/platform.js';

const QUERY = '(max-width: 768px)';

/**
 * Détecte un viewport mobile (≤ 768px, breakpoint responsive du projet).
 * SSR-safe : retourne `false` si `window` est indisponible.
 * App native (Capacitor) : toujours `true` — seul le shell mobile est servi,
 * y compris sur tablette ou en paysage.
 */
export function useIsMobile() {
  const [isMobile, setIsMobile] = useState(() => {
    if (IS_NATIVE) return true;
    if (typeof window === 'undefined' || !window.matchMedia) return false;
    return window.matchMedia(QUERY).matches;
  });

  useEffect(() => {
    if (IS_NATIVE) return undefined;
    if (typeof window === 'undefined' || !window.matchMedia) return undefined;
    const mq = window.matchMedia(QUERY);
    const handler = (e) => setIsMobile(e.matches);
    mq.addEventListener('change', handler);
    // Resynchronise à l'effet (le state initial peut dater du SSR).
    setIsMobile(mq.matches);
    return () => mq.removeEventListener('change', handler);
  }, []);

  return isMobile;
}
